import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

const AuthRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAdmin, loading } = useAuth();
  
  // Get the redirect path from the URL or use the home page as default
  const from = location.state?.from?.pathname || "/";

  useEffect(() => {
    // If still loading auth state, do nothing
    if (loading) return;

    // If no user is logged in, redirect to login
    if (!user) {
      navigate("/auth", { state: { from: location }, replace: true });
      return;
    }

    // If user is admin, redirect to admin dashboard
    if (isAdmin) {
      navigate("/admin/dashboard", { replace: true });
      return;
    }

    // For regular users, redirect to the originally requested page or home
    navigate(from, { replace: true });
  }, [user, isAdmin, loading, navigate, from, location]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background">
      <div className="text-center p-8 max-w-md w-full">
        <div className="flex justify-center mb-4">
          <Loader2 className="h-12 w-12 animate-spin text-primary" />
        </div>
        <h2 className="text-2xl font-semibold mb-2">
          {loading ? "Checking your session..." : "Redirecting you..."}
        </h2>
        <p className="text-muted-foreground">
          Please wait while we prepare your dashboard.
        </p>
      </div>
    </div>
  );
};

export default AuthRedirect;
